import { api } from "@/lib/axios";

export const clientHomeApi = {
  getAllProjects: () => api.get(`workspace/all-projects`)
};
